export const printMailPackage = async (dealId: string, documentTypes: string[]) => {
  // Create a print-friendly window with all documents
  const printWindow = window.open('', '_blank');
  if (!printWindow) return;

  const printStyles = `
    <style>
      @media print {
        @page {
          margin: 0.75in;
          size: letter;
        }
        body {
          font-family: Arial, sans-serif;
          font-size: 11pt;
          line-height: 1.5;
          color: #000;
        }
        .page-break {
          page-break-after: always;
        }
        .document {
          margin-bottom: 2rem;
        }
        h1, h2 {
          color: #8B4513;
        }
        .header {
          text-align: center;
          margin-bottom: 2rem;
        }
        .header h1 {
          font-size: 18pt;
          margin-bottom: 0.25rem;
        }
        .header p {
          color: #FF6B35;
          font-size: 12pt;
        }
        .section {
          margin: 1rem 0;
        }
        .signature-line {
          border-top: 1px solid #000;
          width: 300px;
          margin-top: 3rem;
        }
      }
      @media screen {
        body {
          padding: 2rem;
          max-width: 8.5in;
          margin: 0 auto;
        }
      }
    </style>
  `;

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Mail Package</title>
        ${printStyles}
      </head>
      <body>
        <div id="print-content">
          <p>Loading documents...</p>
        </div>
        <script>
          window.onload = function() {
            window.print();
            setTimeout(function() {
              window.close();
            }, 500);
          };
        </script>
      </body>
    </html>
  `);

  printWindow.document.close();
};
